import axiosInstance from "@/utils/axios";

export const callsApi = {
  getCallableUsers: () => axiosInstance.get("/api/calls/callable-users"),

  getCallableDepartments: () =>
    axiosInstance.get("/api/calls/callable-departments"),

  getAvailableStaff: (departmentKey) =>
    axiosInstance.get(`/api/calls/department/${encodeURIComponent(departmentKey)}/available-staff`),
};
